import { defineMessages } from 'react-intl';

export default defineMessages({
    stepCoverables: {
        id: 'quoteandbind.RecVehProduct.wizard.step.Coverables',
        defaultMessage: 'Coverables'
    },
    questions: {
        id: 'quoteandbind.RecVehProduct.wizard.step.Questions',
        defaultMessage: 'Questions'
    },
    stepCoverages: {
        id: 'quoteandbind.RecVehProduct.wizard.step.Coverages',
        defaultMessage: 'Coverages'
    },
    exposures: {
        id: 'quoteandbind.RecVehProduct.wizard.step.Exposures',
        defaultMessage: 'Exposures'
    }
    // add string ids and default values for localization here
});
